<template lang="pug">
	div
		loading(:active.sync="busy", :is-full-page="false", loader="spinner")
		h4 {{ title }}
		.inner-form-full-width
		apexchart(:type="type", :options="chartOptions", :series="chartSeries")
</template>
<script>
import moment from 'moment';

export default {
  name: 'ReportGraph',

  props: ['title', 'type', 'data', 'filters'],
  computed: {
    enrichedData() {
      const data = Object.assign({}, this.data || {});
      if (this.title === 'General Performance') {
        data.transformData = {
          metrics: {
            clicks(v) {
              return Math.round(v / 1000);
            },
          },
        };
        data.transformLabel = {
          metrics: {
            clicks(v) {
              return `${v} (k)`;
            },
          },
        };
      }
      return data;
    },
    chartOptions() {
      if (!this.queryResponse) {
        return {};
      }
      let options = {
        responsive: [
          {
            breakpoint: undefined,
            options: {},
          },
        ],
      };
      switch (this.type) {
        case 'donut':
          options.labels = this.queryResponse.records.map((r) =>
            r[this.enrichedData.dimensions[0]] ? r[this.enrichedData.dimensions[0]].name : '',
          );
          break;
        case 'line':
          if (this.enrichedData.group_timeframe === 'day') {
            options.xaxis = {
              categories: this.queryResponse.records.map((r) => r.group_date),
            };
          } else if (this.enrichedData.group_timeframe === 'hour') {
            console.log('Not supported yet');
          } else {
            options.xaxis = {
              categories: this.queryResponse.records.map((r) =>
                r[this.enrichedData.dimensions[0]] ? r[this.enrichedData.dimensions[0]].name : '',
              ),
            };
          }
          break;
      }
      return options;
    },
    chartSeries() {
      if (!this.queryResponse) {
        return [];
      }
      this.queryResponse.records.map((r) => {
        if (this.enrichedData.transformData && this.enrichedData.transformData.metrics) {
          for (let k in this.enrichedData.transformData.metrics) {
            r[k].v = this.enrichedData.transformData.metrics[k](r[k].v);
          }
        }
      });
      switch (this.type) {
        case 'donut': {
          let values = this.queryResponse.records.map((r) => r[this.enrichedData.metrics[0]].v);
          return values;
        }
        case 'line': {
          let series = [];
          this.enrichedData.metrics.forEach((m) => {
            let lbl = m;
            if (
              this.enrichedData.transformLabel &&
              this.enrichedData.transformLabel.metrics &&
              this.enrichedData.transformLabel.metrics[m]
            ) {
              lbl = this.enrichedData.transformLabel.metrics[m](lbl);
            }
            let serie = {
              name: lbl,
              data: [],
            };
            this.queryResponse.records.forEach((r) => {
              serie.data.push(r[m].v);
            });
            series.push(serie);
          });
          return series;
        }
      }
      return [];
    },
  },
  data() {
    return {
      busy: false,
      queryResponse: null,
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.filters.datePicker.dateRange.startDate && this.filters.datePicker.dateRange.endDate) {
          this.loadData();
      }
    }, 1000);
  },
  watch: {
    filters: {
      handler() {
        this.loadData();
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    async loadData() {
      this.busy = true;
      let params = {
        export: 0,
        page: 1,
        page_size: this.enrichedData.limit,
        group_timeframe: this.enrichedData.group_timeframe || '',
        offer_id: this.filters.offer_id.map((r) => r.id).join(','),
        complex_offer_id: this.filters.complex_offer_id.map((r) => r.id).join(','),
        timezone: this.filters.datePicker.timezone,
        date_start: this.filters.datePicker.dateRange.startDate,
        date_end: this.filters.datePicker.dateRange.endDate,
        sort_col: this.enrichedData.sort[0],
        sort_dir: this.enrichedData.sort[1],
        metrics: this.enrichedData.metrics,
        dimensions: this.enrichedData.dimensions,
        filters: {
          subsource_data: 0,
          has_conversions: 0,
          ...this.enrichedData.filters,
        },
      };
      let resp = await this.$ovReq.post('reports/query', params);
      this.queryResponse = resp;
      this.busy = false;
    },
  },
};
</script>
